let CardEligibility = {};


CardEligibility = (function () {
  function isNonCraftableCard(card) {
    if (!card) return false;
    if (typeof card.isNonCraftable === 'boolean') {
      return card.isNonCraftable;
    }
    const type = String(card.type || '').toLowerCase();
    if (type !== 'character') return false;
    if (card.isForged === true) return false;
    if (String(card.collection || '') === 'Moon Foundry') return false;
    return true;
  }

  function isExchangeListableCard(card) {
    if (!card) return false;
    const type = String(card.type || '').toLowerCase();
    if (type !== 'character') return false;
    return !isNonCraftableCard(card);
  }

  return {
    isNonCraftableCard,
    isExchangeListableCard,
  };
})();

export { CardEligibility };
